<template>
  <!-- <div class="d-flex justify-center">
    <div class="main-card mt-3"> -->
  <v-container class="mt-3">
    <v-row>
      <v-col cols="12" md="6">
        <!-- <v-card>
          <v-card-text> -->
        <v-row v-if="step === 0">
          <v-col cols="12" class="text-center pb-0">
            <h3 class="text-h4">Select a plan</h3>
            <p class="text-subtitle-1">
              Unlock exclusive features and benefits with our PRO plan.
            </p>
          </v-col>
          <v-col cols="12" class="mt-0 pt-0 pb-0">
            <v-card outlined class="mt-3" color="orange lighten-2 ">
              <v-card-title
                class="text-center d-flex justify-center"
                style="flex-wrap: wrap"
              >
                <v-icon
                  size="40px"
                  class="mr-2 hidden-sm-and-down"
                  color="yellow"
                >
                  mdi-flash
                </v-icon>

                <h4
                  class="text-h5"
                  style="
                    word-break: normal;
                    overflow-wrap: normal;
                    white-space: normal;
                  "
                >
                  Flash sale - more than 50% off!
                </h4>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" class="text-center">
                    <h4 class="text-h5 white--text">{{ timerString }}</h4>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" class="mt-0 pt-0 pb-0">
            <v-radio-group v-model="selRadio" mandatory>
              <v-card
                outlined
                class="mt-3 ribbon-card"
                style="min-height: 120px"
                v-for="option in options"
                :key="option.name"
              >
                <div v-if="option.tag" class="ribbon">{{ option.tag }}</div>
                <v-card-text class="mt-0 pt-0 mb-0 pb-0">
                  <v-row class="mt-0 pt-0 mb-0 pb-0">
                    <v-col cols="12" class="d-flex text-center mt-2 ml-2">
                      <v-radio v-model="option.selected">
                        <template v-slot:label>
                          <span class="text-h6">{{ option.name }}</span>
                        </template>
                      </v-radio>
                    </v-col>
                    <v-col cols="12" class="d-flex mt-0 pt-0 mb-0 pb-0">
                      <div
                        class="text-subtitle-1 mr-2"
                        style="text-decoration: line-through"
                      >
                        {{ option.oldPrice }}
                      </div>
                      <div class="text-subtitle-1">
                        {{ option.price }} /{{ option.period }}
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-radio-group>
          </v-col>
          <v-col cols="12">
            <div class="d-flex">
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                class="mt-3"
                min-width="150px"
                large
                @click="btnNext"
                :loading="buyProLoading"
              >
                Next
              </v-btn>
            </div>
          </v-col>
          <v-col cols="12" v-if="errorMsg">
            <v-alert type="error" outlined>
              {{ errorMsg }}
            </v-alert>
          </v-col>
        </v-row>
        <v-row v-if="step === 1">
          <v-col v-if="!stripeLoading" cols="12">
            <div id="checkout">
              <!-- Checkout will insert the payment form here -->
            </div>
          </v-col>
          <v-col
            v-if="stripeLoading"
            cols="12"
            style="height: 50vh"
            class="d-flex justify-center align-center"
          >
            <v-progress-circular
              :size="50"
              indeterminate
              color="primary"
              class="d-flex justify-center align-center"
            ></v-progress-circular>
          </v-col>
          <v-col cols="12" v-if="!stripeLoading">
            <div class="d-flex">
              <v-btn
                color="primary"
                class="mt-3"
                min-width="150px"
                large
                @click="btnBack"
              >
                Back
              </v-btn>
              <v-spacer></v-spacer>
            </div>
          </v-col>
        </v-row>
        <!-- </v-card-text>
        </v-card> -->
      </v-col>
      <v-col cols="12" md="6">
        <v-row>
          <v-col cols="12">
            <v-img
              src="../assets/pro-icon-3.jpg"
              contain
              class="mt-3 mb-3"
              style="max-height: 200px; max-width: 100%"
              alt="FaangIT.com PRO plan icon"
            ></v-img>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex justify-center align-center">
            <div style="max-width: 400px">
              <v-row>
                <v-col
                  cols="12"
                  v-for="feature in proFeatures"
                  :key="feature.header"
                >
                  <div class="d-flex align-center mb-2">
                    <v-icon class="mr-2">{{ feature.icon }}</v-icon>
                    <span class="text-h5">{{ feature.header }}</span>
                  </div>
                  <ul>
                    <li
                      v-for="bullet in feature.bulletpoints"
                      :key="bullet"
                      class="ml-2 text-body-1"
                    >
                      {{ bullet }}
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js";

export default {
  name: "Checkout",
  data() {
    return {
      stripeCheckout: null,
      step: 0,
      timerString: "",
      selRadio: "weekly",
      buyProLoading: false,
      errorMsg: "",
      options: [
        {
          selected: "weekly",
          name: "Weekly",
          period: "week",
          price: "$4.99",
          oldPrice: "$11.99",
          tag: "",
        },
        {
          selected: "monthly",
          name: "Monthly",
          period: "month",
          price: "$14.99",
          oldPrice: "$34.99",
          tag: "Most popular",
        },
        {
          selected: "annually",
          name: "Annually",
          period: "year",
          price: "$99.99",
          oldPrice: "$199.99",
          tag: "Best value",
        },
      ],
      proFeatures: [
        {
          icon: "mdi-lock-open-variant-outline",
          header: "Unlimited access to all features",
          bulletpoints: [
            "Advanced AI resume analysis",
            "Priority support",
            "Exclusive content and resources",
            "Early access to new features",
          ],
        },
        {
          icon: "mdi-face-agent",
          header: "Priority support",
          bulletpoints: ["Fast response times"],
        },
        {
          icon: "mdi-school-outline",
          header: "Exclusive content and resources",
          bulletpoints: [
            "Access to all resume building knowledge articles",
            "In-depth guides and tutorials",
          ],
        },
        {
          icon: "mdi-timer-sand",
          header: "Early access to new features",
          bulletpoints: ["Be the first to try new tools and updates"],
        },
      ],
      stripeLoading: true,
    };
  },
  mounted() {
    this.$utils.visit(this);
    // Set the default selected option
    this.selRadio = this.options[0].selected;
    // Get the option from query params, if exists
    const optionFromQuery = this.$route.query.option;
    console.log("optionFromQuery: " + optionFromQuery);
    if (optionFromQuery) {
      const matchingOption = this.options.find(
        (opt) => opt.selected === optionFromQuery,
      );
      console.log("matchingOption: " + JSON.stringify(matchingOption));
      if (matchingOption) {
        console.log(
          "Found matching option for query param: " +
            JSON.stringify(matchingOption),
        );
        this.selRadio = matchingOption.selected;
        this.step = 1;
      }
    }

    // start timer for flash sale
    this.startFlashSaleTimer();
    const script = document.createElement("script");
    script.setAttribute("src", "https://js.stripe.com/clover/stripe.js");
    document.head.appendChild(script); // Or document.body.appendChild(script)
  },
  methods: {
    startFlashSaleTimer() {
      this.updateTimerVar();
      setInterval(this.updateTimerVar, 1000);
    },
    btnNext() {
      this.step = 1;
      this.initializeStripe();
    },
    btnBack() {
      if (this.stripeCheckout) {
        this.stripeCheckout.destroy();
      }
      this.step = 0;
    },
    async buyPro() {
      this.buyProLoading = true;
      this.errorMsg = "";
      try {
        var resp = await this.$utils.callBackendPost(this, "/api/buyPro", {
          proOption: this.selRadio,
        });
        // on success, setIsPro in store and redirect to propanel with welcome message
        this.$store.commit("setIsPro", true);
        this.$router.push({
          path: "propanel",
          query: { welcome: "true" },
        });
      } catch (error) {
        this.errorMsg = error;
      } finally {
        this.buyProLoading = false;
      }
    },
    updateTimerVar() {
      const endTime = new Date();
      endTime.setHours(23); // Sale ends in 1 hour
      endTime.setMinutes(59);
      endTime.setSeconds(59);
      const now = new Date();
      const diff = endTime - now;

      if (diff <= 0) return "Sale ended";

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      this.timerString = `${days}d ${hours}h ${minutes}m ${seconds}s`;
    },

    async initializeStripe() {
      const stripe = await loadStripe(
        "pk_test_51MLi7LEala6pUpgMcBlfn1ALwkh5691UYSzx7vwCTyBMCuD1rDWGNdyOTidProCDYaEgIhs2l8KgK7BcrQppntvc00fBXaKXeN",
      );

      const gaClientId = await this.$utils.getGaClientId();
      try {
        var resp = await this.$utils.callBackendPost(
          this,
          "/api/create-checkout-session",
          {
            subscriptionSpan: this.selRadio,
            gaClientId,
          },
        );
      } catch (error) {
        console.log("Error creating checkout session: " + error);
        return;
      } finally {
        this.stripeLoading = false;
      }

      this.stripeCheckout = await stripe.initEmbeddedCheckout({
        clientSecret: resp.clientSecret,
      });

      this.stripeCheckout.mount("#checkout");
    },
  },
};
</script>

<style scoped>
.ribbon-card {
  position: relative;
  overflow: hidden;
}
.ribbon {
  position: absolute;
  top: 22px;
  right: -40px;
  background: #02203d;
  color: white;
  padding: 4px 40px;
  transform: rotate(45deg);
  font-size: 12px;
  font-weight: bold;
}
</style>
